import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { getApplicationId, horizontalStepperRepo } from "../../configs/utils";
import { backAction, contactUsAction, continueAction, tryAgainAction, tryAgainBank } from "./action";
import { ACTION } from "./types";
import sharedPropsService from "../../SharedPropsService";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { CreditApplicationStepId } from "../../configs/constants";
export const template = (height, stepper, ctaText, isFromKYC, ifscCode, heading, key1, value1, key2, value2, voltErrorCode, userName, showCta1) => ({
    layout: {
        id: ROUTE.NAME_MISMATCH,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: "nameMismatchDC", type: WIDGET.NAME_MISMATCH }
        ],
    },
    datastore: {
        nameMismatchDC: {
            height: height,
            stepperData: stepper,
            heading: heading,
            contactUsAction: {
                type: ACTION.CONTACT_US,
                routeId: ROUTE.NAME_MISMATCH,
                payload: {}
            },
            tryAgainAction: {
                type: ACTION.TRY_AGAIN,
                routeId: ROUTE.NAME_MISMATCH,
                payload: {
                    value: voltErrorCode
                }
            },
            tryAgainBankAction: {
                type: ACTION.TRY_AGAIN_BANK,
                routeId: ROUTE.NAME_MISMATCH,
                payload: {}
            },
            backAction: {
                type: ACTION.BACK_ACTION,
                routeId: ROUTE.NAME_MISMATCH,
                payload: {}
            },
            modalContinueAction: {
                type: ACTION.CONTINUE_ACTION,
                routeId: ROUTE.NAME_MISMATCH,
                payload: {}
            },
            key1: key1,
            value1: value1,
            key2: key2,
            value2: value2,
            ctaText: ctaText,
            isFromKYC: isFromKYC,
            ifscCode: ifscCode,
            userName: userName,
            showCta1: showCta1
        }
    },
});
export const nameMismatchMF = {
    onLoad: async ({ getHeight, network }, { ctaText, isFromKYC, ifscCode, heading, key1, value1, key2, value2, voltErrorCode, shouldCallMismatchApi = false }) => {
        const stepper = await horizontalStepperRepo(network);
        const user = await sharedPropsService.getUser();
        const userName = user?.linkedBorrowerAccounts[0]?.accountHolderName;
        const applicationId = await getApplicationId();
        let _heading;
        let _key1;
        let _value1;
        let _key2;
        let _value2;
        let _isFromKYC;
        let _ifscCode;
        if (shouldCallMismatchApi) {
            const persistNameMismatchResponse = await network.get(`${api.persistNameMismatch}${applicationId}`, {
                headers: await getAppHeader()
            });
            if (persistNameMismatchResponse?.status === 200) {
                const currentStepId = persistNameMismatchResponse?.data?.currentStepId;
                let nameMismatchData;
                if (currentStepId === CreditApplicationStepId.KYC_DOCUMENTS) {
                    _isFromKYC = true;
                    nameMismatchData = persistNameMismatchResponse?.data?.kycDocumentVerificationFailureDetails?.nameMatchFailureDetails;
                }
                if (currentStepId === CreditApplicationStepId.BANK_ACCOUNT_VERIFICATION) {
                    _isFromKYC = false;
                    nameMismatchData = persistNameMismatchResponse?.data?.bankMismatchDetails?.bankAccountVerificationFailureDetails?.nameMatchFailureDetails;
                    _ifscCode = persistNameMismatchResponse?.data?.bankMismatchDetails?.bankIfscCode.slice(0, 4);
                }
                if (nameMismatchData) {
                    _heading = nameMismatchData?.description;
                    _key1 = nameMismatchData?.source?.description;
                    _value1 = nameMismatchData?.source?.value;
                    _key2 = nameMismatchData?.target?.description;
                    _value2 = nameMismatchData?.target?.value;
                }
            }
        }
        else {
            _heading = heading;
            _key1 = key1;
            _value1 = value1;
            _key2 = key2;
            _value2 = value2;
            _isFromKYC = isFromKYC;
            _ifscCode = ifscCode;
        }
        const showSupportingDocumentCTA = true;
        return Promise.resolve(template(getHeight(), stepper, ctaText, _isFromKYC, _ifscCode, _heading, _key1, _value1, _key2, _value2, voltErrorCode, userName, showSupportingDocumentCTA));
    },
    actions: {
        [ACTION.CONTACT_US]: contactUsAction,
        [ACTION.TRY_AGAIN]: tryAgainAction,
        [ACTION.TRY_AGAIN_BANK]: tryAgainBank,
        [ACTION.BACK_ACTION]: backAction,
        [ACTION.CONTINUE_ACTION]: continueAction,
    }
};
